var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"add-episode-player-wrapper"},[_c('player-embed',{attrs:{"player-type":"custom","player-embed":_vm.playerEmbed,"show-hash":_vm.show.hash}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }